import * as React from 'react'
import QRCode from 'qrcode.react'
import { connect } from 'react-redux'

import { Button } from 'reactstrap'
import MobileStoreButton from 'react-mobile-store-button'

import { User } from '../../lib/interfaces/User.interface'

export interface ScanProps {
  user: User
  accessToken: string
}

class ScanQRLoginPage extends React.PureComponent<ScanProps> {  
  render() {    
    const { user, accessToken } = this.props
    const testJSON = `{"userId":"${user.id}","firstName":"Ravel","lastName":"Antunes","token":"${accessToken}"}`

    const isiOSDevice = navigator && navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

    return (
      <div className="page">
        <div className="px-3 d-flex flex-column justify-content-center mt-4">
          <h5 className="title">Scanner Login</h5>
          <div className="d-flex justify-content-center bd-highlight mb-3">
            <QRCode value={testJSON} size={250} />
          </div>

          {isiOSDevice && (
            <div className="my-3">
              <a href={`ggamerica://login?token=${accessToken}`}>
                <Button>Log in</Button>
              </a>
            </div>
          )}

          <MobileStoreButton
            store="ios"
            url="https://scanner.ggamerica.com/latest/index.html"
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
  accessToken: auth.accessToken
})

export default connect(mapStateToProps)(ScanQRLoginPage)


// WEBPACK FOOTER //
// ./src/routes/scans/ScanQRLogin.page.tsx